export enum PAY_CHANNEL {
  WECHAT = 'wechat',
  ALIPAY = 'alipay',
}

export enum SKU_TYPE {
  VIP = 'member',
  PURCHASE = 'purchase',
  ACTIVITY = 'activity',
}

export enum ORG_TYPE {
  PERSONAL = 'personal',
  TEAM = 'team',
}

export enum POD_PAYMENT_TAB {
  LINGDOU = 'lingdou',
  STORAGE = 'storage',
}
